import { fetchBaseQuery } from '@reduxjs/toolkit/query';
import { ASSISTANT_API_URL } from '@skynet/config-provider';
import { prepareAuthHeaders } from '@skynet/data-auth-api';

/**
 * Base query for the Assistant API.
 */
export const assistantApiBaseQuery = fetchBaseQuery({
  baseUrl: ASSISTANT_API_URL,
  prepareHeaders: prepareAuthHeaders,
});
